import http from '@/utils/http.js'

/*
 * @DESC:api接口
 */
const GET_CASHIER_STASTICS = "/api/getCashierStastic",//获取收银台统计
	GET_CASHIER_TREND = "/api/getCashierTrend"//交易趋势

export default {
	getCashierStastic: ({
		commit
	}, params={}) => {
		return http.get(GET_CASHIER_STASTICS, params)
	},
	getCashierTrend: ({
		commit
	}, params={}) => {
		return http.get(GET_CASHIER_TREND, params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/pay_count/actions.js